import { initialStateArticle } from './initialState';
import { atom } from 'jotai';

export const articlePayloadAtom = atom(initialStateArticle);
export const stepAtom = atom(null);
